import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import { useState, useEffect } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  getVisitasTrabajo,
  createVisitaTrabajo,
  updateVisitaTrabajo,
} from "../../components/functions/Projects";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import CrearVisitaModal from "./CrearVisitaModal";
import EditarVisitaModal from "./EditarVisitaModal";
import LoaderDialog from "../../ui/loader/Loader";

const VisitasTrabajoModal = ({ open, onClose, API_URL, asignacion }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [visitas, setVisitas] = useState([]);

  const [openCrearVisitaModal, setOpenCrearVisitaModal] = useState(false);

  const [selectedVisitaId, setSelectedVisitaId] = useState(null);
  const [openEditarVisitaModal, setOpenEditarVisitaModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);
      const res = await getVisitasTrabajo(
        API_URL,
        asignacion.contenidoDinamicoId
      );
      setVisitas(res);
      setShowLoader(false);
    };

    if (open) {
      fetchData();
    }
  }, [open]);

  const crearVisita = async (payload) => {
    setShowLoader(true);
    await createVisitaTrabajo(API_URL, asignacion.contenidoDinamicoId, payload);
    setSelectedVisitaId(null);
    setOpenCrearVisitaModal(false);
    setShowSnackbar(true);
    setSnackbarMessage("Visita creada correctamente");
    const res = await getVisitasTrabajo(
      API_URL,
      asignacion.contenidoDinamicoId
    );
    setVisitas(res);
    setShowLoader(false);
  };

  const editarVisita = async (payload) => {
    setShowLoader(true);
    await updateVisitaTrabajo(API_URL, payload);
    setSelectedVisitaId(null);
    setOpenEditarVisitaModal(false);
    setShowSnackbar(true);
    setSnackbarMessage("Visita actualizada correctamente");
    const res = await getVisitasTrabajo(
      API_URL,
      asignacion.contenidoDinamicoId
    );
    setVisitas(res);
    setShowLoader(false);
  };

  const handleClose = () => {
    setSelectedVisitaId(null);
    setOpenCrearVisitaModal(false);
    setOpenEditarVisitaModal(false);
    setVisitas([]);
    onClose();
  };

  const columns = [
    {
      accessorFn: (row) => row.tipoVisita.descripcion,
      header: "Tipo de visita",
      size: 50,
    },
    {
      accessorFn: (row) =>
        new Date(row.fecha).toLocaleDateString("es-MX", {
          dateStyle: "short",
          timeZone: "UTC",
        }),
      header: "Fecha",
      size: 10,
    },
    {
      accessorKey: "comentarios",
      header: "Comentarios",
      size: 160,
    },
    {
      accessorFn: (row) => (row.mostrarReporte ? "Sí" : "No"),
      header: "Mostrar en reporte",
      size: 10,
    },
    {
      id: "editar",
      header: "Editar",
      size: 10,
      Cell: ({ cell, table }) => {
        return (
          <IconButton
            onClick={() => {
              setSelectedVisitaId(cell.row.original.id);
              setOpenEditarVisitaModal(true);
            }}
          >
            <DriveFileRenameOutlineIcon htmlColor="rgb(34, 61, 81)" />
          </IconButton>
        );
      },
    },
  ];

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: visitas,
    enableSorting: false,
    enableFilters: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    layoutMode: "grid",
    defaultColumn: {
      minSize: 40,
      size: 80,
    },
  });

  return (
    <>
      <Dialog fullWidth maxWidth="lg" open={open} onClose={handleClose}>
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <DialogTitle>
          <p style={{ margin: "0 16px 0 0" }}>Visitas trabajo</p>
          <CustomButton
            text={"Nueva visita"}
            color={"#FFFFFF"}
            background={"#223D51"}
            fontStyle={"normal"}
            fontWeight={500}
            fontSize={"14px"}
            width={"120px"}
            height={"28px"}
            type={"button"}
            onClick={() => setOpenCrearVisitaModal(true)}
          />
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              height: "400px",
              padding: "8px 0",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              width: "100%",
            }}
          >
            <div style={{ width: "100%", margin: "10px 0 " }}>
              <MaterialReactTable table={table} />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <CustomButton
            background={"#FFFFFF"}
            color={"#223D51"}
            text="Cerrar"
            height="40px"
            fontWeight="700"
            fontSize="14px"
            border="1px solid #D9D9D9"
            type="button"
            width={"100px"}
            onClick={handleClose}
          />
        </DialogActions>
      </Dialog>
      <CrearVisitaModal
        open={openCrearVisitaModal}
        onClose={() => setOpenCrearVisitaModal(false)}
        onConfirm={crearVisita}
        API_URL={API_URL}
        asignacion={asignacion}
      />
      <EditarVisitaModal
        open={openEditarVisitaModal}
        onClose={() => {
          setSelectedVisitaId(null);
          setOpenEditarVisitaModal(false);
        }}
        onConfirm={editarVisita}
        API_URL={API_URL}
        id={selectedVisitaId}
      />
      <LoaderDialog open={showLoader} />
    </>
  );
};

export default VisitasTrabajoModal;
